export default "__VITE_ASSET__7ea1a178__"